/*
 * @Descripttion:
 * @version:
 * @Author: pengmiaopei
 * @Date: 2021-10-29 13:56:30
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2021-11-28 15:59:42
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\store\modules\acl.js
 */
import { authentication } from '@/config'
const state = {
  admin: false,
  role: ['0'],
  ability: [],
}
const getters = {
  admin: (state) => state.admin,
  role: (state) => state.role,
  ability: (state) => state.ability,
}
const mutations = {
  setFull(state, admin) {
    state.admin = admin
  },
  setRole(state, role) {
    state.role = role
  },
  setAbility(state, ability) {
    state.ability = ability
  },
}
const actions = {
  setFull({ commit }, admin) {
    commit('setFull', admin)
  },
  setRole({ commit, dispatch }, role) {
    //roles存在了两个地方  一个是  user +  acl（主要控制的地方）
    commit('setRole', role)
    commit('user/setRoles', role, { root: true })
    // dispatch('routes/setRoutes', authentication, { root: true })
  },
  setAbility({ commit }, ability) {
    commit('setAbility', ability)
  },
}
export default { state, getters, mutations, actions }
